import { render, staticRenderFns } from "./UsageRecordDetails.vue?vue&type=template&id=3af22053&scoped=true&"
import script from "./UsageRecordDetails.vue?vue&type=script&lang=js&"
export * from "./UsageRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./UsageRecordDetails.vue?vue&type=style&index=0&id=3af22053&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af22053",
  null
  
)

export default component.exports